<template>
  <div>
    <div
      ref="canvas"
      class="map-canvas"
    />
    <div ref="infowindow_content">
      <img
        id="place-icon"
        src=""
        width="16"
        height="16"
      >
      <span
        id="place-name"
        class="title"
      /><br>
      <span id="place-address" />
    </div>
  </div>
</template>
<script>
const google = window.google
export default {
  name: 'OnboardingMap',
  props: ['place'],
  data () {
    return {
      map: null,
      marker: [],
      infowindow: null,
      infowindowContent: null,
    }
  },
  watch: {
    place (newPlace) {
      this.getMap()
    },
  },
  mounted () {
    const element = this.$refs.canvas
    const options = {
      zoom: 13,
      center: { lat: 40.7128, lng: -74.0060 },
    }

    this.map = new google.maps.Map(element, options)

    this.marker = new google.maps.Marker({
      map: this.map,
      anchorPoint: new google.maps.Point(0, -29),
    })

    this.infowindow = new google.maps.InfoWindow()
    this.infowindowContent = this.$refs.infowindow_content
    this.infowindow.setContent(this.infowindowContent)
    this.infowindow.close()

    this.getMap()
  },
  methods: {
    getMap () {
      if (this.place) {
        this.map.setCenter(this.place.geometry.location)
        this.map.setZoom(17) // Why 17? Because it looks good.

        this.marker.setPosition(this.place.geometry.location)
        this.marker.setVisible(true)

        // pop up on marker point
        this.infowindowContent.children['place-icon'].src = this.place.icon
        this.infowindowContent.children['place-name'].textContent = this.place.name
        this.infowindowContent.children['place-address'].textContent = this.fullAddress
        this.infowindow.open(this.map, this.marker)
      }
    },
  },
}
</script>
<style>
.map-canvas {
  width: 650px;
  height: 423px;
  margin: 0 auto;
  background: gray;
}
</style>
